import { FC, JSX } from "react";
import tabHomeIcon from "../../../assets/images/tab-home-white.svg";
import tabHomeSelectedIcon from "../../../assets/images/tab-home-orange.svg";
import tabCalendarIcon from "../../../assets/images/tab-calender-white.svg";
import tabCalendarSelectedIcon from "../../../assets/images/tab-calender-orange.svg";
import tabMembershipIcon from "../../../assets/images/tab-membership-white.svg";
import tabMembershipSelectedIcon from "../../../assets/images/tab-membership-orange.svg";
import tabProfileIcon from "../../../assets/images/tab-profile-white.svg";
import tabProfileSelectedIcon from "../../../assets/images/tab-profile-orange.svg";
import starIcon from "../../../assets/images/tab-selected-star.svg";

interface HomeScreenTabBarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const HomeScreenTabBar: FC<HomeScreenTabBarProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const tabs: Array<{
    id: string;
    label: string;
    icon: JSX.Element;
    activeIcon: JSX.Element;
  }> = [
    {
      id: "home",
      label: "Home",
      icon: <img src={tabHomeIcon} alt="Home Icon" />,
      activeIcon: <img src={tabHomeSelectedIcon} alt="Home Active Icon" />,
    },
    {
      id: "calendar",
      label: "Calendar",
      icon: <img src={tabCalendarIcon} alt="Calendar Icon" />,
      activeIcon: (
        <img src={tabCalendarSelectedIcon} alt="Calendar Active Icon" />
      ),
    },
    {
      id: "membership",
      label: "Membership",
      icon: <img src={tabMembershipIcon} alt="Membership Icon" />,
      activeIcon: (
        <img src={tabMembershipSelectedIcon} alt="Membership Active Icon" />
      ),
    },
    {
      id: "profile",
      label: "Profile",
      icon: <img src={tabProfileIcon} alt="Profile Icon" />,
      activeIcon: (
        <img src={tabProfileSelectedIcon} alt="Profile Active Icon" />
      ),
    },
  ];

  const handleTabChange = (tabId: string): void => {
    setActiveTab(tabId);
    sessionStorage.setItem("selectedHomeTab", tabId);
  };

  return (
    <nav className="home-screen-tab-bar">
      {tabs.map((tab) => {
        const isActive: boolean = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            className="home-screen-tab-button"
            onClick={() => handleTabChange(tab.id)}
          >
            {isActive && (
              <div className="tab-selected-star">
                <img src={starIcon} alt="star-icon" />
              </div>
            )}
            <div className="tab-icon">
              {isActive ? tab.activeIcon : tab.icon}
            </div>
            <div className={`tab-label${isActive ? " tab-label-active" : ""}`}>
              {tab.label}
            </div>
          </button>
        );
      })}
    </nav>
  );
};

export default HomeScreenTabBar;
